import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, MenuItem, Select, Typography } from "@mui/material";
import { inject, observer } from "mobx-react";
import * as React from "react";
import WithManufacturer from "../../contexts/WithManufacturer";
import { Product } from "../../stores/product/Product";
import { RootStore } from "../../stores/rootStore";

interface IProps {
  store?: RootStore;
  applicationId: string;
  product: Product;
  children: React.ReactNode;
}

const EditState: React.FC<IProps> = (props) => {
  const { product, children, applicationId, store } = props;
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [newState, setNewState] = React.useState(product.state || "");

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleConfirmRequest = async () => {
    setLoading(true);
    const { snackStore, productStore } = store!;

    const success = await productStore.setProductProperty(
      applicationId,
      product.randmarSKU || "",
      "State",
      newState?.toString()
    );
    if (success) {
      snackStore.showResult(success);
    }
    setLoading(false);
    setOpen(false);

    await productStore.getProduct(applicationId, product.randmarSKU || "");
  };

  const propertyChange = (newValue: string) => {
    setNewState(newValue);
  };

  return (
    <>
      <Box display={"contents"} onClick={handleOpen}>
        {children}
      </Box>
      <Dialog
        open={open}
        onClose={loading ? undefined : handleCancel}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
          Edit Product State
        </DialogTitle>
        <div hidden={loading}>
          <DialogContent>
            <Select
              value={newState}
              fullWidth
              onChange={(e) => propertyChange(e.target.value as string)}
            >
              <MenuItem key="StateActive" value="Active">
                Active
              </MenuItem>
              <MenuItem key="StateDiscontinued" value="Discontinued">
                Discontinued
              </MenuItem>
              <MenuItem key="StateHold" value="Hold">
                Hold
              </MenuItem>
            </Select>
          </DialogContent>
          <DialogActions
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button onClick={handleCancel} color="primary">
              Cancel
            </Button>
            <Button
              variant="contained"
              title="Confirm changes"
              onClick={handleConfirmRequest}
              disabled={newState === product.state || loading || newState === ""}
            >
              Confirm
            </Button>
          </DialogActions>
        </div>
        <div hidden={!loading} style={{ textAlign: "center" }}>
          <Typography>Please wait...</Typography>
          <LinearProgress />
        </div>
      </Dialog>
    </>
  );
};

export default WithManufacturer(inject("store")(observer(EditState)));
